<template>
  <Content>
    <Block>
      <BlockHeader>
        <h1>{{ $t('camera_check_header') }}</h1>
      </BlockHeader>

      <p>{{ bodyText }}</p>

      <Modal
        :title="$t('more_information_video_why_header')"
        :buttonLabel="$t('button_close')"
      >
        <template v-slot:activator="{ on, attrs }">
          <p>
            <a v-bind="attrs" v-on="on">{{
              $t('camera_check_more_information')
            }}</a>
          </p>
        </template>

        {{ $t('more_information_video_why_detail') }}
      </Modal>

      <BlockActions>
        <template v-if="errNoRecorder">
          <Button :to="{ name: 'Home' }" class="wider-btn">
            {{ $t('button_continue') }}
          </Button>
        </template>
        <template v-else>
          <Button to="/video-check" class="wider-btn">
            {{ $t('camera_check_button_continue_with') }}
          </Button>
          <Button @click="handleDeclined" type="tertiary" class="wider-btn">
            {{ $t('camera_check_button_continue_without') }}
          </Button>
        </template>
      </BlockActions>
    </Block>
  </Content>
</template>

<script>
import {
  Button,
  Content,
  Block,
  BlockHeader,
  BlockActions,
  Modal
} from '@neurotrack/web-shared-components'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'VideoInfo',
  components: {
    Button,
    Block,
    BlockHeader,
    BlockActions,
    Content,
    Modal
  },
  computed: {
    ...mapState('video', ['errNoRecorder']),
    bodyText() {
      return this.errNoRecorder
        ? this.$t('camera_check_media_recorder_unsupported')
        : this.$t('camera_check_intro')
    }
  },
  methods: {
    ...mapActions('video', ['declineCamera']),
    handleDeclined() {
      this.declineCamera()
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
/**
 * @todo - we need to come up with a better strategy for buttons
 * when the content is too big
 */
.wider-btn {
  max-width: 22.5rem;
}
</style>
